// extracted by mini-css-extract-plugin
export default {"actionListTitle":"IssueTemplateItem-module__actionListTitle--mKoCB","templateItemContainer":"IssueTemplateItem-module__templateItemContainer--_dwDr"};